import { Layout } from '@/views/tracker';

export default {
    path: '/tracker',
    component: Layout,
    children: [
        { path: 'list', component: () => import('@/views/tracker/ThreadList.vue') },
        { path: 'thread', name: "thread", component: () => import('@/views/tracker/shreadList/Thread.vue') },
        { path: 'buy-sell', component: () => import('@/views/tracker/BuySell.vue') },
    ]
};
